module.exports = __webpack_public_path__ + "static/04-db9e12967342daafd1ae5391e0a2b9f8.jpg";